import './Michael.css';
import fahrradImg from '../../assets/images/michael_fahrrad.jpeg';
import weinImg from '../../assets/images/michael_wein.png';
import anbauImg from '../../assets/images/michael_anbau.png';

function Michael() {
  return (
    <section id="michael" className="michael">
      <div className="michael__inner">

        <div className="michael__header">
          <span className="michael__label">Serial Entrepreneur · Wein- &amp; Genussexperte · Rainmaker</span>
          <h2 className="michael__title">Michael B. Spreckelmeyer</h2>
          <div className="michael__divider" />
        </div>

        <div className="michael__layout">
          <div className="michael__content">
            <p className="michael__text">
              Michael Spreckelmeyer wurde in den USA geboren und wuchs in Deutschland, Südafrika und
              New York auf. Seit mehr als drei Jahrzehnten ist er als Unternehmer tätig und verbindet
              unternehmerische Erfahrung, strategisches Denken, Genusskompetenz und
              Bewusstseinsentwicklung auf einzigartige Weise.
            </p>
            <p className="michael__text">
              Bereits während seiner Schulzeit machte er sich erstmals selbstständig. Parallel zu
              Abitur und BWL-Studium entwickelte er eine große Leidenschaft für die Themen Marketing,
              Persönlichkeitsentwicklung und Unternehmertum. Geprägt wurde er dabei unter anderem von
              den Arbeiten von Dale Carnegie, Frank Bettger, Al Ries, Jack Trout, Fredmund Malik und
              Peter Drucker. Deren Ideen über Führung, Positionierung und persönliche Wirksamkeit
              beeinflussen sein Denken bis heute.
            </p>
            <p className="michael__text">
              In den 1990er Jahren gründete und entwickelte Spreckelmeyer mehrere Unternehmen und
              engagierte sich früh als Investor und Business Angel. Mit der eVision-Ventures AG schuf
              er eines der frühen Venture-Capital-Modelle für Gründer in Deutschland. Nach der
              Übernahme des Unternehmens durch die Gold-Zack AG wurde er im Jahr 2000 zum damals
              jüngsten Vorstand eines DAX-100-Unternehmens berufen. In diesen Jahren war er an
              zahlreichen Unternehmensgründungen, Beteiligungen und Transaktionen beteiligt, unter
              anderem in den Bereichen Internet, Börsenportale, Künstliche Intelligenz, AdTech und
              digitale Geschäftsmodelle.
            </p>
            <p className="michael__text">
              Parallel dazu entwickelte sich eine zweite große Leidenschaft: die Welt des Weins und
              des Genusses.
            </p>
            <p className="michael__text">
              Ausgelöst durch eine außergewöhnliche Verkostung gereifter Bordeaux-Weine begann Anfang
              der 2000er Jahre seine intensive Beschäftigung mit Wein als Kulturgut, Genussmittel und
              Wertanlage. Es folgten zahlreiche Reisen in die bedeutendsten Weinregionen Europas,
              unzählige Verkostungen sowie ein enger Austausch mit Winzern, Weinmachern und
              internationalen Weinexperten.
            </p>
            <p className="michael__text">
              2003 machte Spreckelmeyer seine Leidenschaft zur neuen Berufung und gründete seinen
              ersten Weinhandel. Aufgrund seiner Expertise im Bereich Weinraritäten und seiner engen
              Kontakte zu führenden Wein-Auktionshäusern wurde er unter anderem mit der Konzeption der
              Sonderschau „Wein als Geldanlage“ auf der Internationalen Anlegermesse (IAM) betraut. Es
              folgten weitere renommierte Engagements, darunter die Mitwirkung an der legendären
              „Fascination Riesling“-Verkostung auf der ProWein gemeinsam mit Jancis Robinson (MW)
              sowie zahlreiche Projekte an der Schnittstelle von Wein, Kultur und Genuss.
            </p>
            <p className="michael__text">
              Mit dem 2016 eröffneten ROCAILLE in Düsseldorf fand diese Entwicklung ihren vorläufigen
              Höhepunkt. Das Café, Bistrot und Weinrestaurant vereint anspruchsvolle Küche, entspannte
              Gastlichkeit und eine außergewöhnliche Weinkultur. Mit einer Weinkarte von weit über
              2.000 Positionen entwickelte sich das ROCAILLE zu einer der renommiertesten
              Weinadressen Deutschlands. Internationale Weinführer und Gastronomiemagazine zeichneten
              das Haus mehrfach aus.
            </p>
            <p className="michael__text">
              Der Falstaff kürte das Konzept mehrfach zum „besten Weinbistro/Restaurant Deutschlands“.
              Zitat: „Wer hier nicht glücklich wird, wird es nirgendwo!“ Heute ist das ROCAILLE die
              Bühne für Spreckelmeyers Leidenschaft für Gastfreundschaft und gelebte Genusskultur.
            </p>
            <p className="michael__text">
              Im Übergang vom siebten zum achten Jahrsiebt trat eine dritte Berufung zunehmend in den
              Mittelpunkt seines Wirkens: Bewusstseinsentwicklung und Potenzialentfaltung.
            </p>
            <p className="michael__text">
              Daraus entstanden drei Herzensprojekte:
            </p>
            <ul className="michael__projects">
              <li className="michael__project">fias qui es – Werde, wer du bist!</li>
              <li className="michael__project">The Art of Jump-Start</li>
              <li className="michael__project">Rain Unlimited</li>
            </ul>
          </div>

          <div className="michael__images">
            <div className="michael__img-portrait">
              <img src={fahrradImg} alt="Michael B. Spreckelmeyer" className="michael__img" />
            </div>
            <div className="michael__img-wrap">
              <img src={weinImg} alt="Weinauswahl" className="michael__img" />
            </div>
            <div className="michael__img-wrap">
              <img src={anbauImg} alt="Weinanbau" className="michael__img michael__img--anbau" />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Michael;
